<template>
    <b-container v-if="calendar">
        <h4>
            Name:
        </h4>
        <b-input type="text" v-model="calendar.name" placeholder="Kategorie Name"
                 :state="failed ? !!calendar.name : undefined"></b-input>
        <b-form-invalid-feedback>
            Bitte geben sie einen Titel ein!
        </b-form-invalid-feedback>
        <br>
        <h4>Beschreibung:</h4>
        <b-input type="text" v-model="calendar.description" placeholder="Darf leer sein"></b-input>
        <br>
        <h4>Farbe:</h4>
        <b-form-radio-group
            v-model="calendar.color"
            :options="colors"
            stacked
        >
        </b-form-radio-group>

        <hr class="mt-4 mb-4">
        <b-button variant="outline-success" @click="handleSubmit" block>
            {{ create ? 'Erstellen' : 'Speichern' }}
        </b-button>
        <b-button v-if="!create"  variant="outline-danger" @click="confirmDeleteCalendar" block>
            Löschen
        </b-button>
    </b-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
    name: 'CalendarEdit',
    props: {
        create: Boolean
    },
    data() {
        return {
            failed: false,
            calendarId: parseInt(this.$route.params.calendarId),
            colors: [
                {
                    html: '<span style="background-color: #dc3545" class="colorOption">Rot</span>',
                    value: '#dc3545'
                },
                {
                    html: '<span style="background-color: #28a745" class="colorOption">Grün</span>',
                    value: '#28a745'
                },
                {
                    html: '<span style="background-color: #007bff" class="colorOption">Blau</span>',
                    value: '#007bff'
                },
                {
                    html: '<span style="background-color: #ffc107" class="colorOption">Gelb</span>',
                    value: '#ffc107'
                },
                {
                    html: '<span style="background-color: #6f42c1" class="colorOption">Lila</span>',
                    value: '#6f42c1'
                },
                {
                    html: '<span style="background-color: #e83e8c" class="colorOption">Pink</span>',
                    value: '#e83e8c'
                },
                {
                    html: '<span style="background-color: #fd7e14" class="colorOption">Orange</span>',
                    value: '#fd7e14'
                }
            ]
        }
    },
    computed: {
        ...mapGetters([
            'getStoredCalendarById',
            'getNewCalendar'
        ]),
        calendar() {
            if (this.create) return this.getNewCalendar
            return this.getStoredCalendarById(this.calendarId)
        }
    },
    methods: {
        ...mapActions([
            'storeCalendar',
            'createCalendar',
            'deleteCalendar',
        ]),
        handleSubmit() {
            if (!this.calendar.name) {
                this.failed = true
                return
            }

            if (this.create) this.createCalendar(this.calendar)
            else this.storeCalendar(this.calendar)
        },
        confirmDeleteCalendar() {
            this.$bvModal.msgBoxConfirm('Wollen Sie den Kalender wirklich löschen ?', {
                title: 'Löschen',
                okVariant: 'outline-danger',
                okTitle: 'Ja',
                cancelTitle: 'Abbrechen',
                cancelVariant: 'outline-success',
                centered: true
            })
                .then(value => {
                    if(value) {
                        this.deleteCalendar(this.calendarId)
                    }
                })
        }
    }
}
</script>

<style>
.colorOption {
    color: white;
    padding: 2px 8px;
    border-radius: 2px;
    min-width: 8ch;
    position: absolute;
    text-align: center;
    margin: 4px 0;
}

.custom-control {
    height: 36px;
    display: flex;
}

.custom-control-label:before {
    top: 0.6rem
}

.custom-control-label:after {
    top: 0.6rem
}
</style>
